module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "container",
    staticClass: "image-slider"
  }, [_c('img', {
    staticClass: "image-slider--image-left",
    attrs: {
      "src": _vm.imageLeft.url,
      "alt": _vm.imageLeft.alt
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-slider--image-right",
    style: (_vm.clipPath),
    attrs: {
      "src": _vm.imageRight.url,
      "alt": _vm.imageRight.alt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-slider--divider",
    style: (_vm.dividerPosition)
  }, [_c('button', {
    staticClass: "image-slider--drag-btn",
    on: {
      "touchstart": _vm.onDragStart,
      "touchend": _vm.onDragEnd,
      "mousedown": _vm.onDragStart,
      "mouseup": _vm.onDragEnd,
      "blur": _vm.onDragEnd
    }
  }, [_c('span', {
    staticClass: "image-slider--btn-text"
  }, [_vm._v("drag me")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00c1679b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c1679b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/image-slider/index.vue
// module id = 500
// module chunks = 7